import { apiClientForm, apiClientLogin, apiClientRouter } from "@/api/softphone_api.js";
import { encryptStorage } from '@/utils/storage';
import ChatService from '@/services/ChatService.js';

// import { authApi } from "@/api/sipmovil_auth_api"

export const authUser = async ({ commit, rootState }) => {
  let ownerId = rootState.softphone_store.ownerId.toString();
  let data = new FormData();
  data.append("owner_id", ownerId);
  const res = await apiClientForm.post("login_hubspot/", data);
  let user = res.data.value;

  let userInfo = {
    Display: user.sipData.extension,
    Pass: user.sipData.password,
    Realm: user.asteriskServer.serverName,
    User: user.sipData.account,
    WSServer: `wss://${user.asteriskServer.serverName}:${user.asteriskServer.serverPort}/ws`,
    Token: user.token,
    User_id:user.userId,
  };


  commit("AUTH_USER_INFO", userInfo);
};

/**
 * Function that performs a HTTP request towards the PBX backend to authenticate a User
 * Commit a mutation to update the logged-in user's information state
 * @param {*} commit parameter that commits an update towards mutations.js to change the state
 * @param {username, password} user data {}
 * @returns whether a user has been successfully authenticated {ok: true}, if not {ok: false} and a <message>
 */
const extractErrorMessage = (error) => {
  const data = error?.response?.data
  if (!data) return 'Error de conexión. Intente nuevamente.'
  if (typeof data === 'string') return data
  if (data.detail) return data.detail
  if (data.value) {
    const val = data.value
    if (typeof val === 'string') return val
    if (val.detail) return val.detail
    if (val.error) return val.error
    if (val.message) return val.message
  }
  if (data.error) return data.error
  if (data.message) return data.message
  return 'Ocurrió un error inesperado.'
}

export const logInSipmovilUser = async ({ commit, dispatch }, user) => {

  const { username, password } = user

  try {
    const basicAuth = "Basic " + btoa(username + ":" + password);
    const { data } = await apiClientLogin.post("/api/v1/login_cloud/",
      { username, password },
      { headers: { Authorization: basicAuth } }
    )

    // Flujo 2FA: el backend devuelve pre2faToken en lugar de la sesión completa
    if (data.pre2faToken) {
      return { ok: true, pre2faToken: data.pre2faToken, maskedEmail: data.maskedEmail }
    }

    // Flujo original: el backend devuelve los datos de sesión directamente
    const sessionData = data.value ?? data
    const userInfo = buildUserInfo(sessionData, username, password)
    commit('AUTH_USER_INFO', userInfo)
    commit('AUTH_COMPANY_INFO', sessionData.company)
    commit('SET_AUDIOS_SOURCE', userInfo)
    dispatch('softphone_store/setContacts', null, { root: true })
    dispatch('fetchPlaybackRate') // FEX-1157: hidrata la velocidad global (no bloquea el login)
    return { ok: true, twoFactorEnabled: sessionData.two_factor_enabled || false, mail: sessionData.mail || '' }

  } catch (error) {
    console.log(error)
    return { ok: false, message: extractErrorMessage(error) }
  }

}

const buildUserInfo = (data, username, password) => {
  const user = data;
  return {
    themeColor: user.themeColor || 'light',
    Display: user.sipData.extension,
    Pass: user.sipData.password,
    Realm: user.asteriskServer.serverName,
    User: user.sipData.account,
    WSServer: `wss://${user.asteriskServer.serverName}:${user.asteriskServer.serverPort}/ws`,
    PbxServer: user.asteriskServer.serverWeb,
    VoiceAgentUrl: user.voice_agent_url || '',
    NotificatorServer: user.asteriskServer.notificatorName,
    Token: user.token,
    User_id: user.userId,
    ShortName: user.shortName,
    Avatar: user.avatar,
    LoggedInPass: password,
    Username: username,
    IsSuperUser: user.is_superuser || false,
    userCompany: user.name_company,
    userCurrentCompany: user.superuser_company,
    ringToneCompany: `https://${user.asteriskServer.serverWeb}${user.ring_tone_company}`,
    mail: user.mail || '',
    twoFactorEnabled: user.two_factor_enabled || false,
    fexIA: user.fexIA || false,
    crm_chat_enabled: user.crm_chat_enabled || false,
    join: user.join,
    groups: user.groups,
    pinnedChats: (user.pinnedChats
      ? (typeof user.pinnedChats === 'string' ? JSON.parse(user.pinnedChats) : user.pinnedChats)
      : []
    ).map(Number),
    in_call_number_blocked: user.in_call_number_blocked,
    out_call_number_blocked: user.out_call_number_blocked,
    can_create_crm_reports: user.can_create_crm_reports,
    audioSipmovil: encryptStorage.getItem('user') !== undefined ? encryptStorage.getItem('user').audioSipmovil : true,
    audioJoin: encryptStorage.getItem('user') !== undefined ? encryptStorage.getItem('user').audioJoin : true,
    // FEX-1157: velocidad de reproducción de notas de voz. El backend NO la envía en
    // el login (es un GET aparte: api/chat/audio-playback-speed/); aquí solo dejamos el
    // default/último persistido. La hidrata `fetchPlaybackRate` tras login/restauración.
    playbackRate: user.playbackRate || 1,
    transferAudio: user.join && user.join.transfer_audio ? `https://${user.asteriskServer.serverWeb}${user.join.transfer_audio}` : '',
    newMessageAudio: user.join && user.join.new_message_audio ? `https://${user.asteriskServer.serverWeb}${user.join.new_message_audio}` : '',
  };
}

// FEX-1157: guarda la preferencia global de velocidad (1 | 1.5 | 2). Commit optimista
// al store/encrypt-storage + POST al backend. El backend reenvía `audio_speed_changed`
// a las otras sesiones del mismo usuario (ver case en realtime.js).
export const setPlaybackRate = async ({ commit, state }, rate) => {
  const prev = state.userInfo.playbackRate || 1;
  commit('SET_PLAYBACK_RATE', rate);
  try {
    await ChatService.updateAudioPlaybackSpeed(rate);
  } catch (e) {
    console.error('[notas_voz] no se pudo guardar la velocidad', e);
    commit('SET_PLAYBACK_RATE', prev); // revertir si el backend rechaza el valor
  }
};

// FEX-1157: hidrata la preferencia desde el backend (GET). Llamar UNA vez tras login/
// restauración (es global, no por chat). Silencioso: si falla queda el default/último.
export const fetchPlaybackRate = async ({ commit }) => {
  try {
    const { data } = await ChatService.getAudioPlaybackSpeed();
    if (data && data.speed != null) commit('SET_PLAYBACK_RATE', Number(data.speed));
  } catch (e) {
    console.error('[notas_voz] no se pudo cargar la velocidad', e);
  }
};

export const verify2FA = async ({ commit, dispatch }, { pre2faToken, otpCode, username, password }) => {
  try {
    const { data } = await apiClientLogin.post("/api/v1/verify_2fa/", { pre2faToken, otpCode })
    const sessionData = data.value ?? data
    const userInfo = buildUserInfo(sessionData, username, password);
    commit('AUTH_USER_INFO', userInfo);
    commit('AUTH_COMPANY_INFO', sessionData.company);
    commit('SET_AUDIOS_SOURCE', userInfo)
    dispatch('softphone_store/setContacts', null, { root: true })
    dispatch('fetchPlaybackRate') // FEX-1157: hidrata la velocidad global tras 2FA
    return { ok: true }
  } catch (error) {
    console.log(error)
    return { ok: false, message: extractErrorMessage(error) }
  }
}

export const request2FAActivation = async () => {
  try {
    const { data } = await apiClientRouter.post("/api/v1/request_2fa_activation/")
    return { ok: true, activationToken: data.activationToken, maskedEmail: data.maskedEmail }
  } catch (error) {
    console.log(error)
    return { ok: false, message: extractErrorMessage(error) }
  }
}

export const confirm2FAActivation = async ({ commit }, { activationToken, otpCode }) => {
  try {
    const { data } = await apiClientRouter.post("/api/v1/confirm_2fa_activation/", { activationToken, otpCode })
    commit('SET_TWO_FACTOR_ENABLED', data.two_factor_enabled)
    return { ok: true, message: data.message || '' }
  } catch (error) {
    console.log(error)
    return { ok: false, message: extractErrorMessage(error) }
  }
}

export const toggle2FA = async ({ commit }) => {
  try {
    const { data } = await apiClientRouter.post("/api/v1/toggle_2fa/")
    commit('SET_TWO_FACTOR_ENABLED', data.two_factor_enabled)
    return { ok: true, twoFactorEnabled: data.two_factor_enabled, message: data.message }
  } catch (error) {
    console.log(error)
    return { ok: false, message: extractErrorMessage(error) }
  }
}

export const resend2FA = async (_, { pre2faToken }) => {
  try {
    const { data } = await apiClientLogin.post("/api/v1/resend_2fa/", { pre2faToken })
    return { ok: true, data }
  } catch (error) {
    console.log(error)
    return { ok: false, message: extractErrorMessage(error) }
  }
}

/**
 * Restores an existing session from encryptStorage into the Vuex store.
 * Used by App.vue on mount to rehydrate the session without triggering 2FA.
 */
export const restoreSession = ({ commit, dispatch }) => {
  const user = encryptStorage.getItem('user')
  if (user === undefined) return { ok: false }
  const userInfo = typeof user === 'string' ? JSON.parse(user) : user
  commit('AUTH_USER_INFO', userInfo)
  commit('SET_AUDIOS_SOURCE', userInfo)
  const company = encryptStorage.getItem('company')
  if (company !== undefined) {
    const companyInfo = typeof company === 'string' ? JSON.parse(company) : company
    commit('AUTH_COMPANY_INFO', companyInfo)
  }
  dispatch('softphone_store/setContacts', null, { root: true })
  dispatch('fetchPlaybackRate') // FEX-1157: re-hidrata la velocidad global al restaurar sesión
  return { ok: true }
}

/**
 * Function to check the validity of the current token to determine whether the user
 * should be logged out or not.
 * @param {*} commit to perform the logout update on a specific state
 * @returns
 */
export const checkAuthentication = async ({ commit }) => {

  const token = encryptStorage.getItem('token')

    if (!token) {
      commit('LOGOUT_SIPMOVIL_USER')
      return {ok:false, message: 'No hay token'}
    }

    // try {
    //   //TODO: Send petition to query logged-in user's token validity

    // } catch (error) {
    //   commit('LOGOUT_SIPMOVIL_USER')
    //   return {ok:false, message: error.response.data.detail}
    // }
}

export const toggleAgrupedView = async ({ state }, val) => {
  state.userInfo.join.agrupedConversations = val;
}